import { useDueDatesAuth } from "../hooks/useDueDatesAuth";
import { useEffect } from "react";

let config = {
  userId: null,
  application: null,
  email: null,
  name: false
};

const UserGuiding = {
  initialize: (application, userId, email, name) => {
    config.application = application;
    config.userId = userId;
    config.email = email;
    config.name = name;
  },
  start: () => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.text = `(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','816748999ID'); `;

    const node = document.head.appendChild(script);

    if (node && window?.userGuiding) {
      window.userGuiding.identify(config.userId, {
        application: config.application,
        email: config.email,
        name: config.name
      });
    }
  }
};

export const useUserGuiding = () => {
  const { UserId, UserFullName, UserEmail } = useDueDatesAuth();

  useEffect(() => {
    if (import.meta.env.PUBLIC_ENVIRONMENT === "PROD" && UserId) {
      UserGuiding.initialize("Due Dates", UserId, UserEmail, UserFullName);
      UserGuiding.start();
    }
  }, [UserId, UserFullName, UserEmail]);
};
